import LogoJamango from 'assets/images/logos/Jamango.svg'
import LogoRelax from 'assets/images/logos/Relax.svg'
import LogoSaunaria from 'assets/images/logos/Saunaria.svg'
import LogoJamangoDarkMode from 'assets/images/logos/Jamango-mode_dark.svg'
import LogoRelaxDarkMode from 'assets/images/logos/Relax-mode_dark.svg'
import LogoSaunariaDarkMode from 'assets/images/logos/Saunaria-mode_dark.svg'
import LogoJamangoMonoMode from 'assets/images/logos/Jamango-mode_mono.svg'
import LogoRelaxMonoMode from 'assets/images/logos/Relax-mode_mono.svg'
import LogoSaunariaMonoMode from 'assets/images/logos/Saunaria-mode_mono.svg'
import { Zone } from 'store/api-slice/types'
import { useMemo } from 'react'

interface UseZonesProps {
    zone: Zone
    mode?: 'light' | 'dark' | 'mono'
}

export const useZones = ({ zone, mode = 'light' }: UseZonesProps) => {
    const fullLogotypes = {
        jamango: {
            light: LogoJamango,
            dark: LogoJamangoDarkMode,
            mono: LogoJamangoMonoMode,
        },
        relax: {
            light: LogoRelax,
            dark: LogoRelaxDarkMode,
            mono: LogoRelaxMonoMode,
        },
        saunaria: {
            light: LogoSaunaria,
            dark: LogoSaunariaDarkMode,
            mono: LogoSaunariaMonoMode,
        },
    }

    const logotypes = useMemo(() => {
        switch (zone) {
            case 'saunaria':
                return [
                    fullLogotypes.saunaria[mode],
                    fullLogotypes.relax[mode],
                    fullLogotypes.jamango[mode],
                ]
            case 'relax':
                return [fullLogotypes.relax[mode], fullLogotypes.jamango[mode]]
            case 'jamango':
                return [fullLogotypes.jamango[mode]]
            default:
                return []
        }
    }, [zone, mode])

    return { logotypes }
}
